import React from "react";
import styles from "./index.module.scss";
import FilterMobileOptions from "../../Filter-mobile-buttons";
import ButtonC from "../../button";
import { useSearchParams } from "react-router-dom";
import { useInvList } from "../../../../hooks/react-query/inv-exchange/useInvList";
import { OverlayPanel } from "primereact/overlaypanel";

interface propsType {
  popRef: React.RefObject<OverlayPanel>;
}

export default function SortModel({ popRef }: propsType) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { refetch } = useInvList();
  const [orderValue, setOrderValue] = React.useState(
    searchParams.get("sortOrder") === "asc"
      ? "Active on Bottom"
      : "Active on Top"
  );
  const handleApply = async () => {
    const updatedParams = new URLSearchParams(searchParams);
    if (orderValue?.length > 0) {
      updatedParams.set(
        "sortOrder",
        orderValue === "Active on Top" ? "desc" : "asc"
      );
    } else {
      updatedParams.delete("sortOrder");
    }
    refetch();
    setSearchParams(updatedParams);
  };

  return (
    <OverlayPanel ref={popRef} className={styles.SortModel}>
      <div className={styles.SortSection}>
        <FilterMobileOptions
          optionVacant={[
            {
              name: "Active on Top",
              code: "Active on Top"
            },
            {
              name: "Active on Bottom",
              code: "Active on Bottom"
            }
          ]}
          occupancy={orderValue}
          setOccupancy={setOrderValue}
          title={"Sort By"}
          border={false}
        />
      </div>
      <ButtonC
        disabled={false}
        type="button"
        label="Apply"
        size="large"
        tabIndex={29}
        className={styles.btn}
        onClick={() => handleApply()}
      />
    </OverlayPanel>
  );
}
